import React, { useEffect, useState } from 'react'
import { Responsive, WidthProvider } from 'react-grid-layout'
import { Box, useTheme } from '@mui/material'

import './style.css'
import MonPortrait from './Component/Card/MonPortrait'
import ProfilInvesti from './Component/Card/ProfilInvesti'
import MonPatrimoineCard from './Component/Card/MonPatrimoineCard'
import PatrimoineNetCard from './Component/Card/PatrimoineNetCard'
import MesObjectifsCard from './Component/Card/MesObjectifsCard'
import ConseilsCard from './Component/Card/ConseilsCard'
import urls from 'utils/urls'
import MonBudget from './Component/Card/MonBudget'
import MaSimulation from './Component/Card/MaSimulation'
import SimulateurDecision from './Component/Card/SimulateurDecision' // LAP-PAT1
import { makeGetRequest } from 'utils/api'
const ResponsiveGridLayout = WidthProvider(Responsive)

function MonPatrimoine() {
  const theme = useTheme()
  const [reports, setReports] = useState([])
  useEffect(() => {
    MonPatrimoineReports()
  }, [])
  const MonPatrimoineReports = async () => {
    const { data } = await makeGetRequest(urls.MonBilanPatrimonialReports, {}, true)
    // const { data } = await makeGetRequest(urls.MonBilanPatrimonialReports,{},true)
    setReports([...data])
  }
  // LAP-PAT1 — layouts alignés sur les clés réelles des enfants ('0'..'8').
  // Avant, les i '1'..'8' ne matchaient qu'une partie des cartes (mix
  // layout/data-grid) → trous et cartes repoussées en bas de grille.
  // La carte 8 (Simulateur de décision) occupe une pleine largeur en bas.
  const layout1 = [
    { i: '0', x: 0, y: 0, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '1', x: 3, y: 0, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '2', x: 6, y: 0, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '3', x: 9, y: 0, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '4', x: 0, y: 3, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '5', x: 3, y: 3, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '6', x: 6, y: 3, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '7', x: 9, y: 3, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '8', x: 0, y: 6, w: 12, h: 4, minW: 4, maxW: 12, minH: 3, maxH: 10 },
  ]
  const layout2 = [
    { i: '0', x: 0, y: 0, w: 5, h: 3, minW: 2, maxW: 10, minH: 3, maxH: 5 },
    { i: '1', x: 5, y: 0, w: 5, h: 3, minW: 2, maxW: 10, minH: 3, maxH: 5 },
    { i: '2', x: 0, y: 3, w: 5, h: 3, minW: 2, maxW: 10, minH: 3, maxH: 5 },
    { i: '3', x: 5, y: 3, w: 5, h: 3, minW: 2, maxW: 10, minH: 3, maxH: 5 },
    { i: '4', x: 0, y: 6, w: 5, h: 3, minW: 2, maxW: 10, minH: 3, maxH: 5 },
    { i: '5', x: 5, y: 6, w: 5, h: 3, minW: 2, maxW: 10, minH: 3, maxH: 5 },
    { i: '6', x: 0, y: 9, w: 5, h: 3, minW: 2, maxW: 10, minH: 3, maxH: 5 },
    { i: '7', x: 5, y: 9, w: 5, h: 3, minW: 2, maxW: 10, minH: 3, maxH: 5 },
    { i: '8', x: 0, y: 12, w: 10, h: 4, minW: 4, maxW: 10, minH: 3, maxH: 10 },
  ]
  const layout3 = [
    { i: '0', x: 0, y: 0, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '1', x: 3, y: 0, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '2', x: 0, y: 3, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '3', x: 3, y: 3, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '4', x: 0, y: 6, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '5', x: 3, y: 6, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '6', x: 0, y: 9, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '7', x: 3, y: 9, w: 3, h: 3, minW: 2, maxW: 6, minH: 3, maxH: 5 },
    { i: '8', x: 0, y: 12, w: 6, h: 4, minW: 3, maxW: 6, minH: 3, maxH: 10 },
  ]
  const layout4 = [
    { i: '0', x: 0, y: 0, w: 4, h: 3, minW: 2, maxW: 4, minH: 3, maxH: 5 },
    { i: '1', x: 0, y: 3, w: 4, h: 3, minW: 2, maxW: 4, minH: 3, maxH: 5 },
    { i: '2', x: 0, y: 6, w: 4, h: 3, minW: 2, maxW: 4, minH: 3, maxH: 5 },
    { i: '3', x: 0, y: 9, w: 4, h: 3, minW: 2, maxW: 4, minH: 3, maxH: 5 },
    { i: '4', x: 0, y: 12, w: 4, h: 3, minW: 2, maxW: 4, minH: 3, maxH: 5 },
    { i: '5', x: 0, y: 15, w: 4, h: 3, minW: 2, maxW: 4, minH: 3, maxH: 5 },
    { i: '6', x: 0, y: 18, w: 4, h: 3, minW: 2, maxW: 4, minH: 3, maxH: 5 },
    { i: '7', x: 0, y: 21, w: 4, h: 3, minW: 2, maxW: 4, minH: 3, maxH: 5 },
    { i: '8', x: 0, y: 24, w: 4, h: 4, minW: 2, maxW: 4, minH: 3, maxH: 10 },
  ]
  const layouts = { lg: layout1, md: layout2, sm: layout3, xs: layout4 }

  const xArr = [0, 3, 6, 9, 0, 3, 6, 9, 0, 3, 6, 9, 0, 3, 6, 9, 0, 3, 6, 9, 0, 3, 6, 9]
  const children = React.useMemo(() => {
    return (
      reports &&
      reports.map((val, idx) => (
        <div
          key={idx}
          style={{ backgroundColor: theme.palette.appBar.main, display: 'grid' }}
          data-grid={{
            // LAP-PAT1 — placement explicite : les 8 cartes existantes sur
            // deux rangées (y calculé, plus de collision), puis la carte
            // Simulateur de décision en pleine largeur SOUS la grille.
            x: val.type === 'simulateur-decision' ? 0 : xArr[idx],
            y: val.type === 'simulateur-decision' ? 99 : Math.floor(idx / 4) * 3,
            w: val.type === 'simulateur-decision' ? 12 : 3,
            h: val.type === 'simulateur-decision' ? 4 : 3,
            minW: 2,
            maxW: 12,
            minH: 3,
            maxH: 10,
          }}
        >
          {val.type === 'mon-portrait' && (
            <MonPortrait updateReports={MonPatrimoineReports} oldData={val.data} />
          )}
          {val.type === 'profil-investisseure' && (
            <ProfilInvesti updateReports={MonPatrimoineReports} oldData={val.data} />
          )}
          {val.type === 'mon-budget' && (
            <MonBudget updateReports={MonPatrimoineReports} oldData={val.data} />
          )}
          {val.type === 'mon-patrimoine' && (
            <MonPatrimoineCard updateReports={MonPatrimoineReports} oldData={val.data} />
          )}
          {val.type === 'patrimoine-net' && (
            <PatrimoineNetCard updateReports={MonPatrimoineReports} oldData={val.data} />
          )}
          {val.type === 'mes-objectifs' && (
            <MesObjectifsCard updateReports={MonPatrimoineReports} oldData={val.data} />
          )}
          {val.type === 'ma-simulation' && (
            <MaSimulation updateReports={MonPatrimoineReports} oldData={val.data} />
          )}
          {val.type === 'conseils' && (
            <ConseilsCard updateReports={MonPatrimoineReports} oldData={val.data} />
          )}
          {/* LAP-PAT1 — Simulateur de décision (moteur de conséquences) */}
          {val.type === 'simulateur-decision' && (
            <SimulateurDecision updateReports={MonPatrimoineReports} oldData={val.data} />
          )}
        </div>
      ))
    )
  }, [reports])

  return (
    <Box maxWidth={1650} ml={'auto'} mr={'auto'}>
      <ResponsiveGridLayout
        className="layout"
        style={{ margin: '10px' }}
        autoSize={true}
        layouts={layouts}
        useCSSTransforms={true}
        breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
        cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
        draggableCancel=".no-drag"
      >
        {children}
      </ResponsiveGridLayout>
    </Box>
  )
}

export default MonPatrimoine
